import axios from 'axios'
// import swal from 'sweetalert'

import getServerURL from '../../../functions/getServerURL'

import { handleErrorFetchingData } from '../../../functions/errorHandling'

let defaultState = {
  genesisAnalyticsOnly: false,
  fetchingProjectAnalytics: false,
  projectsAnalyticsData: {},
  projectListForAnalytics: [],
  projectFilters: {
    projectleadFilters: [],
    analystFilters: [],
    statusFilters: [],
    startdateFilters: [],
    completiondateFilters: [],
    metadataFilters: [],
  },

  fetchingProposalAnalytics: false,
  proposalAnalyticsData: {},
  proposalListForAnalytics: [],
  proposalFilters: {
    categoryFilters: [],
    clientmanagerFilters: [],
    proposalleadFilters: [],
    proposalmetadataFilters: [],
    proposeddurationFilters: [],
    statusFilters: [],
    submissiondateFilters: [],
    submittedtoFilters: [],
  },
}

export default function manageAnalytics(state = defaultState, action) {
  switch (action.type) {
    case "SET_GENESIS_PROJECT_ANALYTICS_ONLY":
      return {...state, genesisAnalyticsOnly: action.payload}
    case "FETCHING_PROJECT_ANALYTICS":
      return {...state, fetchingProjectAnalytics: !state.fetchingProjectAnalytics }
    case "SET_PROJECT_ANALYTICS":
      return { ...state, fetchingProjectAnalytics: false, projectsAnalyticsData: action.payload, projectListForAnalytics: action.payload.projects }
    case "ADD_PROJECT_ANALYTICS_FILTER":
      let { analyticsType, filterType, filterValue } = action.payload
      let projectsToRemove
      if (state.projectsAnalyticsData.hasOwnProperty(analyticsType)) {
        projectsToRemove = state.projectsAnalyticsData[analyticsType][filterValue]
      } else {
        projectsToRemove = state.projectsAnalyticsData['Metadata'][analyticsType][filterValue]
      }
      let filteredProjects = state.projectListForAnalytics.filter(project => {
        return !projectsToRemove.includes(project)
      })

      return {
         ...state,
         projectFilters: {
           ...state.projectFilters,
           [filterType]: [...state.projectFilters[filterType], filterValue],
         },
         projectListForAnalytics: filteredProjects
       }
    case "REMOVE_PROJECT_ANALYTICS_FILTER":
      analyticsType = action.payload.analyticsType
      filterType = action.payload.filterType
      filterValue = action.payload.filterValue

      let projectsToAddBack
      if (state.projectsAnalyticsData.hasOwnProperty(analyticsType)) {
        projectsToAddBack = state.projectsAnalyticsData[analyticsType][filterValue]
      } else {
        projectsToAddBack = state.projectsAnalyticsData['Metadata'][analyticsType][filterValue]
      }

      let updatedFilters = state.projectFilters[filterType].filter(value => value !== filterValue)

      let projectListForAnalytics = [...state.projectListForAnalytics, ...projectsToAddBack]

      projectListForAnalytics = new Set(projectListForAnalytics)
      projectListForAnalytics = Array.from(projectListForAnalytics)

      return {
        ...state,
        projectFilters: {
          ...state.projectFilters,
          [filterType]: updatedFilters,
        },
        projectListForAnalytics
      }
    case "REMOVE_ALL_PROJECT_ANALYTICS_FILTERS_OF_TYPE":
      let analyticsDataOfType = state.projectsAnalyticsData[action.payload.analyticsType]
      let allProjectsOfType = []
      Object.keys(analyticsDataOfType).forEach(key => {
        allProjectsOfType = [...allProjectsOfType, ...analyticsDataOfType[key]]
      })

      projectListForAnalytics = new Set([...state.projectListForAnalytics, ...allProjectsOfType])

      projectListForAnalytics = Array.from(projectListForAnalytics)

      return {
        ...state,
        projectListForAnalytics,
        projectFilters: {
          ...state.projectFilters,
          [action.payload.filterType]: [],
        }
      }
    case "ADD_ALL_PROJECT_ANALYTICS_FILTERS_OF_TYPE":
      return {
        ...state,
        projectFilters: {
          ...state.projectFilters,
          [action.payload.filterType]: action.payload.filterValues,
        }
      }
    case "CLEAR_ALL_PROJECT_ANALYTICS_FILTERS":
      return {
        ...state,
        projectFilters: {
          projectleadFilters: [],
          analystFilters: [],
          statusFilters: [],
          startdateFilters: [],
          completiondateFilters: [],
          metadataFilters: [],
        }
      }


    // PROPOSAL CASES

    case "FETCHING_PROPOSAL_ANALYTICS":
      return {...state, fetchingProposalAnalytics: !state.fetchingProposalAnalytics }
    case "SET_PROPOSAL_ANALYTICS":
      return { ...state, fetchingProposalAnalytics: false, proposalAnalyticsData: action.payload, proposalListForAnalytics: action.payload.proposals }
      case "ADD_PROPOSAL_ANALYTICS_FILTER":
        analyticsType = action.payload.analyticsType
        filterType = action.payload.filterType
        filterValue = action.payload.filterValue
        let proposalsToRemove
        if (state.proposalAnalyticsData.hasOwnProperty(analyticsType)) {
          proposalsToRemove = state.proposalAnalyticsData[analyticsType][filterValue]
        } else {
          proposalsToRemove = state.proposalAnalyticsData['Proposal Metadata'][analyticsType][filterValue]
        }
        let filteredProposals = state.proposalListForAnalytics.filter(proposals => {
          return !proposalsToRemove.includes(proposals)
        })

        return {
           ...state,
           proposalFilters: {
             ...state.proposalFilters,
             [filterType]: [...state.proposalFilters[filterType], filterValue],
           },
           proposalListForAnalytics: filteredProposals
         }
       case "REMOVE_PROPOSAL_ANALYTICS_FILTER":
         analyticsType = action.payload.analyticsType
         filterType = action.payload.filterType
         filterValue = action.payload.filterValue

         let proposalsToAddBack
         if (state.proposalAnalyticsData.hasOwnProperty(analyticsType)) {
           proposalsToAddBack = state.proposalAnalyticsData[analyticsType][filterValue]
         } else {
           proposalsToAddBack = state.proposalAnalyticsData['Proposal Metadata'][analyticsType][filterValue]
         }

         updatedFilters = state.proposalFilters[filterType].filter(value => value !== filterValue)

         let proposalListForAnalytics = [...state.proposalListForAnalytics, ...proposalsToAddBack]

         proposalListForAnalytics = new Set(proposalListForAnalytics)
         proposalListForAnalytics = Array.from(proposalListForAnalytics)

         return {
           ...state,
           proposalFilters: {
             ...state.proposalFilters,
             [filterType]: updatedFilters,
           },
           proposalListForAnalytics
         }
       case "REMOVE_ALL_PROPOSAL_ANALYTICS_FILTERS_OF_TYPE":
         analyticsDataOfType = state.proposalAnalyticsData[action.payload.analyticsType]
         let allProposalsOfType = []
         Object.keys(analyticsDataOfType).forEach(key => {
           allProposalsOfType = [...allProposalsOfType, ...analyticsDataOfType[key]]
         })

         proposalListForAnalytics = new Set([...state.proposalListForAnalytics, ...allProposalsOfType])

         proposalListForAnalytics = Array.from(proposalListForAnalytics)

         return {
           ...state,
           proposalListForAnalytics,
           proposalFilters: {
             ...state.proposalFilters,
             [action.payload.filterType]: [],
           }
         }
       case "ADD_ALL_PROPOSAL_ANALYTICS_FILTERS_OF_TYPE":
         return {
           ...state,
           proposalFilters: {
             ...state.proposalFilters,
             [action.payload.filterType]: action.payload.filterValues,
           }
         }
       case "CLEAR_ALL_PROPOSAL_ANALYTICS_FILTERS":
         return {
           ...state,
           proposalFilters: {
             categoryFilters: [],
             clientmanagerFilters: [],
             proposalleadFilters: [],
             proposalmetadataFilters: [],
             proposeddurationFilters: [],
             statusFilters: [],
             submissiondateFilters: [],
             submittedtoFilters: [],
           }
         }


    default:
      return state
  }
}

// PROJECT ACTIONS

export const toggleGenesisProjectsOnly = (genesisProjectsOnly) => {
  return { type: "SET_GENESIS_PROJECT_ANALYTICS_ONLY", payload: genesisProjectsOnly}
}

export const fetchingProjectAnalytics = () => {
  return { type: "FETCHING_PROJECT_ANALYTICS" }
}

export const setProjectAnalytics = (projectAnalytics) => {
  return { type: "SET_PROJECT_ANALYTICS", payload: projectAnalytics }
}

export const addProjectsAnalyticsFilter = (filterType, filterValue, analyticsType) => {
  return { type: "ADD_PROJECT_ANALYTICS_FILTER", payload: { filterType, filterValue, analyticsType } }
}

export const removeProjectsAnalyticsFilter = (filterType, filterValue, analyticsType) => {
  return { type: "REMOVE_PROJECT_ANALYTICS_FILTER", payload: { filterType, filterValue, analyticsType } }
}

export const removeAllProjectAnalyticsFiltersOfType = (filterType, analyticsType) => {
  return {
    type: "REMOVE_ALL_PROJECT_ANALYTICS_FILTERS_OF_TYPE",
    payload: { filterType, analyticsType }
}
}

export const addAllProjectAnalyticsFiltersOfType = (filterType, filterValues) => {
  return { type: "ADD_ALL_PROJECT_ANALYTICS_FILTERS_OF_TYPE", payload: { filterType, filterValues } }
}

export const clearAllProjectFilters = () => {
  return { type: "CLEAR_ALL_PROJECT_ANALYTICS_FILTERS"}
}

export const getProjectAnalytics = (genesisAnalyticsOnly) => {
  return (dispatch) => {

    let url = getServerURL()

    if (genesisAnalyticsOnly === true) {
      url+= "?genesis_analytics_only=true"
    }

    dispatch(clearAllProjectFilters())
    dispatch(fetchingProjectAnalytics())
    axios({
      method: "GET",
      headers: { "Authorization": "Bearer " + localStorage.getItem("token") },
      url,
    })
    .then(response => {
      dispatch(setProjectAnalytics(response.data))
    })
    .catch(error => {
      dispatch(fetchingProjectAnalytics())
      handleErrorFetchingData(error)
    })
  }
}


// PROPOSAL ACTIONS

export const fetchingProposalAnalytics = () => {
  return { type: "FETCHING_PROPOSAL_ANALYTICS" }
}

export const setProposalAnalytics = (projectAnalytics) => {
  return { type: "SET_PROPOSAL_ANALYTICS", payload: projectAnalytics }
}

export const addProposalAnalyticsFilter = (filterType, filterValue, analyticsType) => {
  return { type: "ADD_PROPOSAL_ANALYTICS_FILTER", payload: { filterType, filterValue, analyticsType } }
}

export const removeProposalAnalyticsFilter = (filterType, filterValue, analyticsType) => {
  return {
    type: "REMOVE_PROPOSAL_ANALYTICS_FILTER",
    payload: { filterType, filterValue, analyticsType }
  }
}

export const removeAllProposalAnalyticsFiltersOfType = (filterType, analyticsType) => {
  return {
    type: "REMOVE_ALL_PROPOSAL_ANALYTICS_FILTERS_OF_TYPE",
    payload: { filterType, analyticsType }
  }
}

export const addAllProposalAnalyticsFiltersOfType = (filterType, filterValues, analyticsType) => {
  return {
    type: "ADD_ALL_PROPOSAL_ANALYTICS_FILTERS_OF_TYPE",
    payload: { filterType, filterValues, analyticsType }
  }
}

export const clearAllProposalFilters = () => {
  return { type: "CLEAR_ALL_PROPOSAL_ANALYTICS_FILTERS"}
}

export const getProposalAnalytics = (filters) => {
  return (dispatch) => {
    dispatch(clearAllProposalFilters())
    dispatch(fetchingProposalAnalytics())
    axios({
      method: "GET",
      url: `${getServerURL()}proposal-analytics`,
      headers: { "Authorization": "Bearer " + localStorage.getItem("token") },
    })
    .then(response => {
      dispatch(setProposalAnalytics(response.data))
    })
    .catch(error => {
      dispatch(fetchingProposalAnalytics())
      handleErrorFetchingData(error)
    })
  }
}



// WEBPACK FOOTER //
// ./src/routes/analytics/reducers/manageAnalytics.js